import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 应急人员列表-未使用
export function listNoUsed(params) {
    return request({
        baseURL,
        url: '/emergencyPerson/listNoUsed',
        method: 'get',
        params
    })
}
// 新增应急人员
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyPerson/save',
        method: 'post',
        data
    })
}
//修改应急人员
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyPerson/update',
        method: 'post',
        data
    })
}
//查询应急人员列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyPerson/list',
        method: 'get',
        params
    })
}
//查询应急人员
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyPerson/detail?id=' + id,
        method: 'get',
    })
}
//删除应急人员
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyPerson/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}